import apiClient from "../../../http-common";

// export const bloodGroupDropdown = ()=>{
//     return country.get(`/misc/bloodGroup`,{
//       headers: {
//         authorization:
//           "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//         Accept: "application/json",
//         "Content-Type": "application/json",}
//     })
//   }

// export const maritalStatusDropdown = () => {
//   return country.get(`/misc/maritalStatus`, {
//     headers: {
//       authorization:
//         "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     }
//   })
// }

export const referEntityDropdown = () => {
  return apiClient.get(`/misc/referralEntity`, {
    headers: {
      authorization:
        "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJNciBOaWxlc2ggU2hpbmRlIiwiZW1wSWQiOjY4LCJlbXBsb3llZVR5cGUiOiJIb3VzZWtlZXBpbmcgSW5jaGFyZ2UiLCJjcmVhdGVkIjoxNjkyNjc2NjU3Nzc2LCJleHAiOjI3NzI2NzY2NTcsInVzZXIiOjE1NCwic3RhdHVzIjp0cnVlLCJ1c2VybmFtZSI6Ik1yIE5pbGVzaCBTaGluZGUifQ.jgfQKryiLdGRm1cHZ8HzJo9fGST-0VRxFDoFzqc_n2gwb_SaE606BNURAAneU4aItK_7ZT0obrslPtFvxsBIMw",
      Accept: "application/json",
      "Content-Type": "application/json",
    }
  })
}



export const bloodGroupDropdown = () => {
  return apiClient.post(`/dropdowns/getBloodGroupDropDown`,)
}

export const maritalStatusDropdown = () => {
  return apiClient.post(`/dropdowns/getMaritalStatusDropDown`,)
}

export const specializationDropdown = () => {
  return apiClient.post(`/subSpecialization/getListForSpecialisation`,)
}


//Post Object API
export const postRefDoctor = (saveObj) => {
  return apiClient.post(`/referDoctor/saveOrUpdate`, saveObj);
};


// export const religionDropdown = ()=>{
//   return apiClient.post(`/subSpecialization/getListForSpecialisation`,)
// }


//Listing API
export const referDoctorListing = (searchObj) => {
  return apiClient.post(`/referDoctor/getList`, searchObj);
};

// Autosearch API
export const referDoctorSearch = (searchString) => {
  return apiClient.post(`/referDoctor/searchString/${searchString}`);
};

//Delete Row Department API
export const deleteRowReferalDoctorApi = (index) => {
  return apiClient.delete(`/referDoctor/deleteById/${index}`);
};

export const prefixDropdown = () => {
  return apiClient.post(`/dropdowns/getPrefixDropDown`,)
}

export const religionDropdown = () => {
  return apiClient.post(`/dropdowns/getReligionDropDown`,)
}

export const motherTonghDropdown = () => {
  return apiClient.post(`/dropdowns/getMotherTongueDropDown`,)
}

export const designationDropdown = () => {
  return apiClient.post(`/dropdowns/getDesignationDropDown`,)
}

export const classificationDropdown = () => {
  return apiClient.post(`/dropdowns/getClassificationDropDown`,)
}


export const doctorTypeDropdown = () => {
  return apiClient.post(`/dropdowns/getDocotorTypeDropDown`,)

}

export const degreeDropdown = () => {
  return apiClient.post(`/dropdowns/getQualificationDropDown`,)

}


export const subSpecializationDropdown = () => {
  return apiClient.post(`/dropdowns/getSubSpecialisationDropDown`,)

}


export const bankDropdown = () => {
  return apiClient.post(`/dropdowns/getBankNameDropDown`,)

}

// FindById API
export const referDoctorFindById = (cabinId) => {
  return apiClient.get(`/referDoctor/getById/${cabinId}`);
};
